import { render, staticRenderFns } from "./CommonDrawer.vue?vue&type=template&id=22388f76&scoped=true"
import script from "./CommonDrawer.vue?vue&type=script&lang=ts"
export * from "./CommonDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22388f76",
  null
  
)

export default component.exports